var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(this.$store.getters.isAuthenticated)?_c('Sidebar',{attrs:{"drawer":_vm.drawer}}):_vm._e(),_c('Header',{on:{"drawer-change":_vm.headerDrawerChange}}),_c('v-content',[_c('ResponseNotification'),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }